import useIsTeamsEnabled from '@/hooks/useIsTeamsEnabled';
import OldWorkspace from '@/pages/Workspace';

import Workspace from './Workspace';

function WorkspaceWrapper() {
  const isTeamsEnabled = useIsTeamsEnabled();

  return isTeamsEnabled ? <Workspace /> : <OldWorkspace />;
}

export default WorkspaceWrapper;
